<template>
  <el-dialog title="请选择上传图片方法" :visible.sync="visible" width="550px" :before-close="handleClose">

      <span slot="footer" class="dialog-footer">
        <el-button class="sub-button" type="primary" icon="el-icon-camera"
                   v-if="uploadType === 'idCardFrontId' || uploadType == 'businessLicenseId' || uploadType == 'idCardReserveId' || uploadType == 'legaPersonReserveId' || uploadType == 'legaPersonFrontId'"
                   @click="uploadFiles(0)">拍 照</el-button>
        <el-button class="sub-button" type="primary" icon="el-icon-upload2"
                   v-if="uploadType === 'idCardFrontId' || uploadType == 'businessLicenseId' || uploadType == 'idCardReserveId' || uploadType == 'legaPersonReserveId' || uploadType == 'legaPersonFrontId'"
                   @click="uploadFiles(1)">上 传</el-button>
        <el-button class="sub-button" type="primary" icon="el-icon-camera" v-if="uploadType === 'scene'"
                   @click="uploadFiles(2)">人脸识别</el-button>
        <el-button class="sub-button" type="primary" icon="el-icon-upload2" v-if="uploadType === 'scene'"
                   @click="uploadFiles(3)">上 传</el-button>
      </span>
  </el-dialog>
</template>

<script>

export default {
  name: "uploadChange",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uploadType: {
      type: String,
      default: ''
    },
  },
  methods: {
    uploadFiles(e) {
      this.$emit('uploadFiles', e)
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(() => {
            this.updateDialog(false)
          })
          .catch(() => {
          });
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
